import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ICaseFeatureInformations } from '../../case-feature-informations.interface';
import { CaseFeatureTypeEnum } from '../../../../../../../../definition/case-features/interfaces/case-feauture.interfaces';

@Component({
  selector: 'app-case-feature-inputs',
  templateUrl: './case-feature-inputs.component.html',
  styleUrl: './case-feature-inputs.component.scss',
})
export class CaseFeatureInputs implements OnInit {
  @Input() item!: ICaseFeatureInformations;
  @Output() valueChange = new EventEmitter<any>();

  ngOnInit() {
    if (this.item.feature.type === CaseFeatureTypeEnum.MultiSelect) {
      if (this.item.answer) {
        this.item.answer = this.item.answer
          .split(',')
          .map((a: string) => a.trim())
          .filter((a: string) => a.length > 0); // boş stringleri ele
      } else {
        this.item.answer = [];
      }
    }

    if (this.item.feature.type === CaseFeatureTypeEnum.Date) {
      const raw = this.item.answer;
      const [day, month, year] = raw.split('.');
      const isoDate = `${year}-${month}-${day}`;
      let dateValue: Date | null = null;

      if (this.item?.answer) {
        const parsedDate = new Date(isoDate);
        dateValue = Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
      }

      this.item.answer = dateValue;
    }
  }

  onValueChange(newValue: any) {
    this.valueChange.emit(newValue);
  }

  onMultiSelectChange(optionValue: any, event: any) {
    if (!Array.isArray(this.item?.answer)) {
      this.item.answer = [];
    }

    if (event.target.checked) {
      this.item.answer = [...this.item.answer, optionValue];
    } else {
      this.item.answer = this.item.answer.filter((v: any) => v !== optionValue);
    }

    this.onValueChange(this.item.answer);
  }

  isOptionSelected(optionValue: any): boolean {
    return (
      Array.isArray(this.item.answer) && this.item.answer.includes(optionValue)
    );
  }

  onRadioChange(selectedValue: any) {
    this.onValueChange(this.item.answer);
  }

  getOptionLabel(option: string): string {
    return option?.replace('_aciklama', '');
  }

  protected readonly CaseFeatureTypeEnum = CaseFeatureTypeEnum;
}
